import { useCurrentRequest } from "../../../../../routing/RequestContext.js";
const useDataGridKey = (props) => {
  const pageName = useCurrentRequest()?.pageName;
  const entityName = typeof props.entities === "string" ? props.entities : props.entities.entityName;
  return props.dataGridKey ?? `${pageName}__${entityName}`;
};
export {
  useDataGridKey
};
//# sourceMappingURL=useDataGridKey.js.map
